import Vue from "vue";
import VueDragscroll from "vue-dragscroll";

Vue.use(VueDragscroll);
